module.exports = __webpack_public_path__ + "img/03_uk.b3105897.svg";